module.exports = __webpack_public_path__ + "static/media/operador-logo-parana-clinicas.6c5a63ea.png";